import React from 'react';

import { Body as BodyText } from 'js/design_system/Body';
import { Heading } from 'js/design_system/Heading';
import { Icon } from 'js/design_system/Icon';

import {
  Header,
  ResponsiveTitleWrap,
  ValueProps,
  ValueProp,
} from './StatelessWorkCardsUpsellModal.styles';

export interface ModalHeaderProps {
  modalTitle: string;
  relatedCountLabel: string | null;
}

export function ModalHeader({
  modalTitle,
  relatedCountLabel,
}: ModalHeaderProps) {
  return (
    <Header>
      <ResponsiveTitleWrap>
        <Heading fontFamily="sans-serif" size="lg" as="h2">
          {modalTitle}
        </Heading>
      </ResponsiveTitleWrap>
      <ValueProps>
        <ValueProp>
          <Icon name="check" size={20} />
          <BodyText size="sm" as="span">
            The paper you are reading
          </BodyText>
        </ValueProp>
        <ValueProp>
          <Icon name="check" size={20} />
          <BodyText size="sm" as="span">
            {relatedCountLabel
              ? `${relatedCountLabel} related papers`
              : 'Related papers'}
          </BodyText>
        </ValueProp>
        <ValueProp>
          <Icon name="check" size={20} />
          <BodyText size="sm" as="span">
            All premium features
          </BodyText>
        </ValueProp>
        <ValueProp className="hideOnMobile">
          <Icon name="check" size={20} />
          <BodyText size="sm" as="span">
            Save hours of searching
          </BodyText>
        </ValueProp>
      </ValueProps>
    </Header>
  );
}

export default ModalHeader;
